import React, { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { toast } from 'sonner';

const AuthSuccessPage = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const { setToken, setUser } = useAuth();

  useEffect(() => {
    const handleOAuthSuccess = async () => {
      const token = searchParams.get('token');
      const error = searchParams.get('error');

      if (error) {
        toast.error('Authentication failed. Please try again.');
        navigate('/login');
        return;
      }

      if (token) {
        try {
          // Store token in localStorage
          localStorage.setItem('token', token);
          
          // Fetch user data
          const API_URL = process.env.REACT_APP_BACKEND_URL;
          const response = await fetch(`${API_URL}/api/auth/me`, {
            headers: {
              'Authorization': `Bearer ${token}`
            }
          });
          
          if (response.ok) {
            const userData = await response.json();
            
            // CRITICAL FIX: Update AuthContext state with token and user
            setToken(token);
            setUser(userData);
            
            // Show success message
            toast.success('Successfully signed in!');
            
            // Smart redirect based on onboarding status
            if (userData.onboarding_completed === false) {
              // New user - redirect to onboarding
              navigate('/onboarding/welcome');
            } else {
              // Returning user - redirect to dashboard
              navigate('/dashboard');
            }
          } else {
            throw new Error('Failed to fetch user data');
          }
        } catch (error) {
          console.error('Auth success error:', error);
          toast.error('Failed to complete sign in');
          navigate('/login');
        }
      } else {
        navigate('/login');
      }
    };

    handleOAuthSuccess();
  }, [searchParams, navigate, setToken, setUser]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-white" data-testid="auth-success-page">
      <div className="text-center">
        <div className="spinner mb-4"></div>
        <p className="text-[#6b7280]">Completing sign in...</p>
      </div>
    </div>
  );
};

export default AuthSuccessPage;
